import React from 'react';
import './App.css';
import RedeemForm from './RedeemForm';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://production';

function refreshPage() {
    window.location.reload(false);
  }

interface ServerData {
  result: string;
  name: string;
  id: number;
  token1: string;
  token2: string;
};

interface AppState {
  serverData: ServerData | null;
  validError: string | null;
  serverError: string | null;
  isBusy: boolean;
};

class NewAccount extends React.Component<any, AppState> {


  constructor(props: any) {
    super(props);
    this.state = {
      serverData: null,
      validError: null,
      serverError: null,
      isBusy: false
    };
  }

  async componentDidMount() {
    this.setState({
      
    });
  }

  async redeem(email: string, name: string, password: string, code: string) {
    this.setState({
      serverError: null,
      validError: null,
      isBusy: true
    });

    const form = new FormData();
    form.append("Name", name);
    form.append("Password", password);
    form.append("Email", email);
    form.append("RegMethod", "regcode");
    form.append("Receipt", code);

    const resp = await fetch(API_ENDPOINT + "/NewAccount/RegisterUser", {
      method: "POST",
      body: form,
    });

    console.log(resp);

    const text = await resp.clone().text();

    resp.json()
      .then(data => {
        console.log(data);
        this.setState({
          serverData: data,
          isBusy: false
        });
      })
      .catch(e => {
        this.setState({
          serverError: text.startsWith("EX") ? text.slice("EX".length) : text,
          isBusy: false
        });
      });
  }
    
  render() {
    const errorText = this.state.validError
      ? this.state.validError
      : this.state.serverError
      ? this.state.serverError
      : null;

    const message = this.state.serverData
      ? <div className="success">
          <p>Your new Star Realms account has been created.</p>
          <p>Please download the app using the links below and login to play!</p>
		  <p><button type="button" className="btn btn-primary" onClick={refreshPage}>Claim Another Code</button></p>
          <div className="links_container">
            <a className="storelogo" href="https://itunes.apple.com/us/app/star-realms/id893447125?mt=8/">
              <img alt="Download on the App Store" src="/Apple_Platform_Badge_Layout_Horizontal.png"/>
            </a>
			<a className="storelogo" href="https://play.google.com/store/apps/details?id=com.starrealms.starrealmsapp&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
              <img alt="Get it on Google Play" src="/Google_Platform_Badge_Layout_Horizontal.png"/>
            </a>
			<a className="storelogo" href="https://store.steampowered.com/app/438140/">
              <img alt="Get it on Steam" src="/Steam_Platform_Badges_Layout_Horizontal_White.png"/>
            </a>
          </div>
		  <p><a className="banner" href="https://apps.apple.com/us/app/star-realms/id1066107760?ls=1&mt=12">Star Realms is also available on the Mac App Store</a></p>
          <p className="smalltext">Apple, the Apple logo, and App Store are trademarks of Apple Inc., registered in the U.S. and other countries. Google Play is a trademark of Google LLC. Steam and the Steam logo are trademarks and/or registered trademarks of Valve Corporation in the U.S. and/or other countries.</p>
        </div>
      : null;

    const form = this.state.serverData ? null : (
      <RedeemForm
        errorText={errorText}
        onValidError={e => this.setState({validError: e})}
        submitCallback={(e,n,p,c) => this.redeem(e,n,p,c)}
        disableRegistration={this.state.isBusy}/>
    );

    return (
      <>
            { message }
            { form }
      </>
    );  
  }
}

export default NewAccount;
